import { __decorate } from "tslib";
import { injectable } from 'inversify';
import { mobileNumberMasking } from '@cores/utils/getUserDisplayInfo';
let SpaceCollaboratorFactoryImpl = class SpaceCollaboratorFactoryImpl {
    createDisplayData(data) {
        return {
            type: data.type,
            displayName: this._getDisplayName(data),
            userContacts: this._getContact(data),
            userCompanyName: this._getCompanyName(data),
            memberCount: this._getMemberCount(data),
            avatar: this._getAvatar(data),
        };
    }
    create(data, currentDefaultRole) {
        return {
            uid: data.user_id,
            ...this.createDisplayData(data),
            ...currentDefaultRole,
        };
    }
    _getAvatar(data) {
        return {
            color: data.avatar.color,
            url: data.avatar.url || undefined,
            firstChar: data.avatar.firstChar,
        };
    }
    _getCompanyName(data) {
        return data.company_name || '';
    }
    _getMemberCount(data) {
        return data.member_total_count || 0;
    }
    _getMobileNumber(data) {
        return data.mobile_number ? mobileNumberMasking(data.mobile_number) : '';
    }
    _getDisplayName(data) {
        return data.displayLabel || this._getMobileNumber(data);
    }
    _getContact(data) {
        if (data.type === 'GROUP') {
            return '';
        }
        const contact = data.user_email || this._getMobileNumber(data);
        if (this._getDisplayName(data) === contact) {
            return '';
        }
        return contact;
    }
};
SpaceCollaboratorFactoryImpl = __decorate([
    injectable()
], SpaceCollaboratorFactoryImpl);
export { SpaceCollaboratorFactoryImpl };
